import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const DeletedRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${pxToRem(20)} ${pxToRem(25)};

  box-shadow: inset 0px ${pxToRem(3)} ${pxToRem(4)} 0px rgba(0, 0, 0, 0.25);
  background: rgb(242, 40, 98);
  color: rgb(255, 255, 255);

  font-size: ${pxToRem(16)};
  font-weight: 500;
`;

export const DeletedRowMessage = styled.span`
  flex-grow: 1; /* Растягивается, занимая доступное пространство */
  font-size: ${pxToRem(18)};
  font-weight: 600;
  padding-left: ${pxToRem(30)};
`;

export const RestoreButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(14)};
  font-weight: 400;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
